<template>
  <!-- 応募 -->
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <div :class="{'my-chlid': speaker==='my', 'other-chlid': speaker==='other'}" v-if="!isError">
      <img class="image-box" :src="files" :onerror="isError=true"/>
    </div>
    <div :class="{'my-chlid': speaker==='my', 'other-chlid': speaker==='other'}">
      <a class="button is-primary file-link is-small" target="_blank" rel="noopener" :href="files" download>
        <span class="mdi mdi-download" style="margin-right: 10px;"></span>
        {{getFilename(filename)}}
      </a>
    </div>
  </div>
</template>

<script>
import hex2rgb from "@/functions/hex2rgb"
// 外部関数
import {
  autoColor,
  shadowStyle
} from "@/functions/balloonFunc"

export default {
  name: "UploadedParts",
  props: ['speaker', 'color', 'filename', 'files'],
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    getFilename (filename) {
      const path_div = filename.split('/')
      return path_div[path_div.length - 1]
    }
  },
  computed: {
  },
  data () {
    return {
      isError: true
    }
  }
};
</script>

<style lang="scss" scoped>
.my-box {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 10px;
  transition: 0.7s;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.my-chlid {
  display: flex;
  justify-content: flex-end;
}
.other-chlid {
  display: flex;
  justify-content: flex-start;
}
.input-on {
  font-size: 14px;
  width: calc(100% - 40px);
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-off {
  font-size: 14px;
  width: 100%;
}
.send-button {
  width: 40px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.image-box {
  width: 240px;
  background: white;
  height: auto;
  object-fit: scale-down;
  border-radius: 8px;
}
.file-link {
  margin-top: 5px; width: 240px; display: flex; justify-content: end; overflow: hidden; text-overflow: ellipsis;
}
</style>
                



// WEBPACK FOOTER //
// src/components/BalloonParts/UploadedParts.vue